"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Layouts = _interopRequireDefault(require("./components/Layouts"));

var _Loading = _interopRequireDefault(require("./components/Loading"));

var _withTheme = _interopRequireDefault(require("./wrappers/with-theme"));

var _ComponentFactory = require("./ComponentFactory");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DefaultLayout = (0, _withTheme["default"])(function (_ref) {
  var theme = _ref.theme,
      component = _ref.component,
      path = _ref.path,
      exact = _ref.exact,
      layoutSettings = _ref.layoutSettings,
      isAuthenticating = _ref.isAuthenticating,
      props = _objectWithoutProperties(_ref, ["theme", "component", "path", "exact", "layoutSettings", "isAuthenticating"]);

  var location = (0, _reactRouterDom.useLocation)(),
      Layout = (0, _lodash["default"])(_Layouts["default"], props.layout, _Layouts["default"]["Sidebar"]);

  if (isAuthenticating) {
    return /*#__PURE__*/_react["default"].createElement(Layout, _extends({}, layoutSettings, props, {
      theme: theme
    }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: path,
      exact: exact
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "fixed top-0 left-0 w-screen h-screen z-50",
      style: {
        backgroundColor: "rgba(0, 0, 0, 0.5)"
      }
    }, /*#__PURE__*/_react["default"].createElement(_Loading["default"], null))));
  }

  return sendToLogin(props) ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: {
      pathname: "/auth/login",
      state: {
        from: (0, _lodash["default"])(location, "pathname")
      }
    }
  }) : sendToHome(props) ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    to: "/"
  }) : /*#__PURE__*/_react["default"].createElement(Layout, _extends({}, layoutSettings, props, {
    theme: theme
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    path: path,
    exact: exact
  }, /*#__PURE__*/_react["default"].createElement(_ComponentFactory.ComponentFactory, {
    config: component
  })));
});

var getAuthLevel = function getAuthLevel(props) {
  return props.auth ? 0 : (0, _lodash["default"])(props, "authLevel", -1);
};

function sendToLogin(props) {
  var requiresAuth = getAuthLevel(props) > -1;
  return requiresAuth && !(0, _lodash["default"])(props, ["user", "authed"], false);
}

function sendToHome(props) {
  return (0, _lodash["default"])(props, ["user", "authLevel"], -1) < getAuthLevel(props);
}

var _default = DefaultLayout;
exports["default"] = _default;